import { render, staticRenderFns } from "./wiki_sticky_header.vue?vue&type=template&id=4aeb4f18&scoped=true"
import script from "./wiki_sticky_header.vue?vue&type=script&lang=js"
export * from "./wiki_sticky_header.vue?vue&type=script&lang=js"
import style0 from "./wiki_sticky_header.vue?vue&type=style&index=0&id=4aeb4f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb4f18",
  null
  
)

export default component.exports